/* eslint-disable react-hooks/exhaustive-deps */
import { Button, message, Select, Slider, Tooltip } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setDraftDialogOpenAdvance,
  setDraftDialogPlay,
} from "store/bailiff/draft/dialog/draft_dialog.action";
import {
  draftDialogDetailSelector,
  draftDialogOpenAdvance,
  draftDialogPlaySelector,
  draftDialogSecondSelector,
} from "store/bailiff/draft/dialog/draft_dialog.selector";
import TriggerPlay from "./trigger/trigger_play";
import TriggerMonitor from "./trigger/trigger_monitor";
import moment from "moment";
import TriggerChange from "./trigger/trigger_change";
import { refineTimer } from "util/refine_timer.function";
import {
  PauseCircleOutlined,
  PlayCircleOutlined,
  SettingOutlined,
  StepBackwardOutlined,
  StepForwardOutlined,
} from "@ant-design/icons";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const PLAYBACK = [
  {
    value: 0.75,
    label: "x0.75",
  },
  {
    value: 1,
    label: "Thường",
  },
  {
    value: 1.5,
    label: "x1.5",
  },
  {
    value: 2,
    label: "x2",
  },
];

const AudioUrl = ({ url }) => {
  // -------------------------- VAR -----------------------------

  // -------------------------- STATE ---------------------------
  const [audio, setAudio] = useState(null);
  const [trigger, setTrigger] = useState(null);
  const [playbackRate, setPlayBackRate] = useState(1);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const detail = useSelector(draftDialogDetailSelector);
  console.log({ detail });
  const play = useSelector(draftDialogPlaySelector);
  const second = useSelector(draftDialogSecondSelector);
  const open = useSelector(draftDialogOpenAdvance);
  const start = detail?.start;
  const end = detail?.end;
  const icon = !play ? <PlayCircleOutlined /> : <PauseCircleOutlined />;
  const title = !play ? "Phát" : "Dừng";
  const duration = refineTimer({ timer: Math.round(second) });

  console.log("rerender", end);

  // -------------------------- FUNCTION ------------------------
  const handleChange = (value) => {
    const id = `change-${moment()?.valueOf()}-${value}`;
    setTrigger(id);
  };

  const togglePLay = useCallback(() => {
    dispatch(setDraftDialogPlay(!play));
  }, [dispatch, play]);

  const handleOpen = () => {
    dispatch(setDraftDialogOpenAdvance(true));
  };

  const handleSelect = (value) => {
    if (!audio) return;
    setPlayBackRate(value);
    audio.playbackRate = value;
  };

  const handlePrev5s = () => {
    if (!audio) return;
    if (second - 5 < start) return message.warning("Không thể quay lại 5s");
    const id = `change-${moment()?.valueOf()}-${second - 5}`;
    setTrigger(id);
  };

  const handleNext5s = () => {
    if (!audio) return;
    if (second + 5 > end) return message.warning("Không thể tới trước 5s");
    const id = `change-${moment()?.valueOf()}-${second + 5}`;
    setTrigger(id);
  };

  // -------------------------- EFFECT --------------------------

  // nếu chạy lố thì sao.
  useEffect(() => {
    if (!audio) return;
    //nếu chưa tới start.
    if (second < start) {
      audio.pause();
      const id = `change-${moment()?.valueOf()}-${start}`;
      dispatch(setDraftDialogPlay(false));
      setTrigger(id);
    }

    //nếu quá end.
    if (second > end) {
      audio.pause();
      const id = `change-${moment()?.valueOf()}-${end}`;
      dispatch(setDraftDialogPlay(false));
      setTrigger(id);
    }
  }, [start, end, second, audio, dispatch]);

  // trigger url.
  useEffect(() => {
    if (!url) return;
    const audio = new Audio(url);
    setAudio(audio);

    return () => {
      // Pause the audio, remove its source to release resources.
      audio.pause();
      audio.removeAttribute("src");
      audio.load();
    };
  }, [url]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderSetting = () => {
    return (
      <Tooltip title="Mở editor nâng cao">
        <Button
          shape="circle"
          onClick={handleOpen}
          type="text"
          icon={<SettingOutlined />}
        />
      </Tooltip>
    );
  };

  const renderPrevNext = () => {
    return (
      <div className="flex flex-row gap-1">
        <Tooltip title="Quay về 5s">
          <Button
            onClick={handlePrev5s}
            type="text"
            icon={<StepBackwardOutlined />}
          />
        </Tooltip>
        <Tooltip title={title}>
          <Button
            onClick={togglePLay}
            shape="circle"
            type="text"
            icon={<span className="anticon">{icon}</span>}
          />
        </Tooltip>
        <Tooltip title="Tới trước 5s">
          <Button
            onClick={handleNext5s}
            type="text"
            icon={<StepForwardOutlined />}
          />
        </Tooltip>
      </div>
    );
  };

  const renderPlaybackRate = () => {
    return (
      <Select
        variant="outline"
        options={PLAYBACK}
        value={playbackRate}
        onSelect={handleSelect}
        style={{ minWidth: 100 }}
      />
    );
  };

  const renderUI = () => {
    return (
      <>
        {renderPrevNext()}
        {renderPlaybackRate()}
        <Slider
          value={second}
          min={start}
          max={end}
          step={0.01}
          tooltip={false}
          onChange={handleChange}
          style={{ width: "100%" }}
        />
        <span style={{ fontSize: 12, color: "#aeaeae", minWidth: 100 }}>
          {duration}
        </span>
        {/* {renderSetting()} */}
      </>
    );
  };
  // -------------------------- MAIN ----------------------------
  if (open) return null;
  return (
    <div
      className="bg-zinc-100"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        borderRadius: 30,
        padding: 8,
        marginBottom: 20,
      }}
    >
      {renderUI()}
      <TriggerPlay audio={audio} />
      <TriggerMonitor audio={audio} />
      <TriggerChange trigger={trigger} audio={audio} />
    </div>
  );
};
export default AudioUrl;
